export default __webpack_public_path__ + "static/media/astra-daihatsu.7154fe45.svg";